/** Situações das áreas */
export interface AreaSituacao {
    id: number;
    nome: string;
}

export const areaSituacaoAtiva: AreaSituacao = {id: 1, nome: 'Ativa'};
export const areaSituacaoInativa: AreaSituacao = {id: 2, nome: 'Inativa'};

export const areasSituacoes: AreaSituacao[] = [
    areaSituacaoAtiva,
    areaSituacaoInativa
];

/** Verifica se a situação informada é igual a Ativa */
export function isSituacaoAtiva(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === areaSituacaoAtiva.id;
}

/** Verifica se a situação informada é igual a Inativa */
export function isSituacaoInativa(situacao: number): boolean {
    if (!situacao) {
        return false;
    }
    return situacao === areaSituacaoInativa.id;
}
